// extracted by mini-css-extract-plugin
export default {"badge":"EnrichmentBadge_badge__rNL1f","broker":"EnrichmentBadge_broker__hTTFY","nearmap":"EnrichmentBadge_nearmap__YwU9T","cape":"EnrichmentBadge_cape__UxcX2"};